/** Labels. One place, so a status never reads two ways on two screens. */

const MEETING_STATUS: Record<string, string> = {
  SCHEDULED: 'Scheduled',
  LIVE: 'In progress',
  ENDED: 'Ended',
  CANCELLED: 'Cancelled',
}

export const meetingStatusLabel = (code?: string | null) =>
  !code ? '—' : (MEETING_STATUS[code] ?? code)

const ADMISSION: Record<string, string> = {
  WAITING: 'Waiting',
  ADMITTED: 'Admitted',
  DENIED: 'Refused',
  REMOVED: 'Removed',
}

export const admissionLabel = (code?: string | null) =>
  !code ? '—' : (ADMISSION[code] ?? code)

/**
 * "Today at 14:30", "Tomorrow at 09:00", otherwise the date.
 *
 * A meeting is read against the day it happens, not against an ISO string: somebody scanning
 * the diary is asking "is this one mine, now?" and a timestamp makes them do the arithmetic.
 */
export function whenLabel(iso: string): string {
  const at = new Date(iso)
  const time = at.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  const days = Math.round(
    (startOfDay(at).getTime() - startOfDay(new Date()).getTime()) / 86400000)
  if (days === 0) return `Today at ${time}`
  if (days === 1) return `Tomorrow at ${time}`
  if (days === -1) return `Yesterday at ${time}`
  return `${at.toLocaleDateString([], { day: 'numeric', month: 'short' })} at ${time}`
}

function startOfDay(d: Date) {
  const copy = new Date(d)
  copy.setHours(0, 0, 0, 0)
  return copy
}

/** How long somebody has been standing at the door, in words a host can act on. */
export function waitedLabel(since: string): string {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(since).getTime()) / 1000))
  if (seconds < 60) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} min`
  return `${Math.round(minutes / 60)} h`
}
